import { Map } from 'immutable';
import { createSelector } from 'reselect';

const selectMarketplaceApiKeyObject = (state) =>
  state.getIn(['me', 'marketplace', 'apiKey'], Map());

const selectMarketplaceModal = (state) => state.getIn(['me', 'marketplace', 'modal'], Map());

const selectAuthProfileInformation = (state) => state.getIn(['me', 'marketplace', 'profileId']);

const selectMatchesResults = (state) => state.getIn(['me', 'marketplace', 'matchesResults']);

const selectMatchesResultsDataById = (state) =>
  state.getIn(['me', 'marketplace', 'matchesResultsData', 'byId']);

const makeSelectMarketplaceModalOpen = () =>
  createSelector(selectMarketplaceModal, (state) => state.getIn(['open'], false));

const makeSelectMarketplaceModalOptions = () =>
  createSelector(selectMarketplaceModal, (state) => state.getIn(['options'], Map()));

const makeSelectMarketplaceApiKeyLoading = () =>
  createSelector(selectMarketplaceApiKeyObject, (state) =>
    state.getIn(['network', 'loading'], false),
  );

const makeSelectMarketplaceApiKeyError = () =>
  createSelector(selectMarketplaceApiKeyObject, (state) =>
    state.getIn(['network', 'error'], false),
  );

const makeSelectMarketplaceApiKeySuccess = () =>
  createSelector(selectMarketplaceApiKeyObject, (state) =>
    state.getIn(['network', 'success'], false),
  );

const makeSelectMarketplaceApiKey = () =>
  createSelector(selectMarketplaceApiKeyObject, (state) => state.getIn(['data'], false));

const makeSelectProfileInformation = () =>
  createSelector(selectAuthProfileInformation, (state) => {
    const profileInformation = state?.get('data');
    const id = profileInformation?.profileId;

    return typeof id === 'string' ? profileInformation : null;
  });

const makeSelectMatchesResultsDataByProductId = (productId) =>
  createSelector(selectMatchesResultsDataById, (state) =>
    state.getIn([productId.toString(), 'data'], null),
  );

const makeSelectMatchesResultsDataLoading = (productId) =>
  createSelector(selectMatchesResultsDataById, (state) => {
    return state.getIn([productId.toString(), 'network', 'loading'], false);
  });

export {
  makeSelectMarketplaceApiKey,
  makeSelectMarketplaceApiKeyError,
  makeSelectMarketplaceApiKeyLoading,
  makeSelectMarketplaceApiKeySuccess,
  makeSelectMarketplaceModalOpen,
  makeSelectMarketplaceModalOptions,
  makeSelectProfileInformation,
  makeSelectMatchesResultsDataByProductId,
  makeSelectMatchesResultsDataLoading,
};
